<template>
  <div class="home">
    <Header />
    <div class="main" id="main-right" :class="headerStyle">
      <router-view></router-view>
    </div>
    <Footer v-if="$route.name != 'Download'" />
    <FloatButton />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import FloatButton from "../components/FloatButton.vue";

export default {
  name: "home",
  components: {
    Header,
    Footer,
    FloatButton,
  },
  data() {
    return {
      headerStyle: "",
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.setHeaderCss(route.name);
      },
      // 深度观察监听
      deep: true,
    },
  },
  created() {
    this.$store.dispatch("get_user_info_friend");
    this.setHeaderCss(this.$route.name);
  },
  methods: {
    setHeaderCss(name) {
      if (name == "Index") {
        this.headerStyle = "headerMin";
      } else {
        this.headerStyle = "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>

.main {
  width: 1200px;
  min-height: calc(100vh - 218px);
  padding-top: 70px;
  margin: 0 auto;
}

@media only screen and (min-device-width: 520px) and (max-device-width: 1024px) {
  /* 平板样式调整 */
  .main {
    // width: calc(100% - 16px);
    min-height: calc(100vh - 218px);
    margin: 0 auto;
    padding:0 8px;
    padding-top: 70px;
  }
}

// .main {
//   min-height: calc(100vh - 218px);
//   padding-top: 70px;
//   margin: 0 auto;
// }
// @media only screen and (min-device-width: 520px) and (max-device-width: 1024px) {
//   /* 平板样式调整 */
//   .main {
//     min-height: calc(100vh - 218px);
//     margin: 0 auto;
//     padding:0 8px;
//     padding-top: 70px;
//   }
// }


.headerMin {
  min-height: calc(100vh - 288px);
  padding-top: 0px;
}
</style>
